import { InputLabel, MenuItem, Select } from '@mui/material'

interface SelectLabelProps {
  name: string
  value?: any
  onChange?: any
  listItem: {
    id: number
    name?: any
  }[]
  required?: boolean
}

const SelectLabel = ({
  name,
  onChange,
  listItem,
  value,
  required,
}: SelectLabelProps) => {
  return (
    <>
      <InputLabel
        required={required}
        sx={{
          marginLeft: '12px',
          marginTop: '12px',
          color: 'grey.800',
          fontSize: '16px',
          lineHeight: '16px',
          fontWeight: '700',
          marginBottom: '4px',
          height: '100%',
          '& .MuiFormLabel-root-MuiInputLabel-root.Mui-focused': {
            color: 'grey.800',
          },
        }}
      >
        {name}
      </InputLabel>
      <Select
        labelId="demo-simple-select-standard-label"
        id="demo-simple-select-standard"
        onChange={onChange}
        value="1"
        label={name}
        sx={{
          '& .MuiInput-input:focus': {
            backgroundColor: 'background.default',
          },
        }}
        disableUnderline
      >
        {listItem.map((item: any, key: any) => (
          <MenuItem value={item.id} key={key}>
            {item.itemName}
          </MenuItem>
        ))}
      </Select>
    </>
  )
}

export default SelectLabel
